import loadable from "@loadable/component";
import { inject } from "mobx-react";
import React from "react";
import type { Store } from "../../../../client/stores";
import { Remote } from "../../components/remote/Remote.component";
import type { AptivadaAppFragment } from "../../generated/webapi.g";
import { getContest } from "../../services/Aptivada";
import type { PageBlockInterface } from "../Block.component";

const Contest = loadable(() => import("./Contest.component"));

interface ContestLoaderProps extends PageBlockInterface {
    store?: Store;
}

export const ContestLoader = inject("store")(({ block, params, isPrimary, store }: ContestLoaderProps) => {
    if (!params || !params.slug || !store) {
        return null;
    }

    const { site, tags } = store;
    const { slug: accountId } = site.index;
    const appId = params.slug.split("-").slice(-1)[0];
    const cacheKey = `contestloader-${accountId}-${appId}`;

    if (!appId) {
        return null;
    }

    return (
        <Remote<AptivadaAppFragment | null | undefined>
            cacheKey={cacheKey}
            loader={() => getContest({ accountId, appId }, tags.surrogateKeys)}
            showLoading={isPrimary}
        >
            {({ data }) => (data ? <Contest contest={data} block={block} /> : null)}
        </Remote>
    );
});

export default ContestLoader;
